<template src="./index.html">
</template>
<script>
	import uploadfile from '../uploadFile/index.vue'
	import uploadfilemore from '../uploadFileMore/index.vue'
export default {
  name: '',
  components: {
	  uploadfile,
	  uploadfilemore
  },
  props:{
	  updiag:{
		  type:Boolean,
		  default:false
	  },
	  formlist:{
		  type:Array,
		  default:()=>[]
	  },
	  formdata:{
		  type:Object,
		  default: {}
	  },
	  multiple:{
	  	type: Boolean,
	  	default: false
	  },
	  filets:{
		  type:String,
		  default: "支持扩展名：rar、zip、doc、docx、pdf、jpg、xls、xlsx、txt、xlsm"
	  },
  },
  data: function() {
    return {
		upformdata:{}
    };
  },
  watch: {
  	updiag: function(indexVal, oldVal) {
		if (indexVal) {
			this.upformdata={}
			this.$nextTick(()=>{
				this.$refs['uploadfileRef'].forrefresh()
			})
  	}
  	},
  },
  created() {
  },
  methods: {
	  forsubmit(){
		  this.$emit("forsubmit",{
			  formdata:this.formdata,
			  upformdata:this.upformdata
		  })  
	  },
	  closediag(){
	  	  this.$emit("closediag",false)
	  },
	  getdata(e){
		   this.$emit("getdata",e)
	  },
	  getuploadparams(e){
		   this.$emit("getuploadparams",e)
	  },
	  fordownloadmb(){
		   this.$emit("fordownloadmb",true)
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
